import { inject, computed } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss';

export function useRouteData(uid) {
  const jssStore = inject('jssStore');
  const mainData = jssStore.routeData()?.placeholders?.['jss-main']?.filter((c) => {
    if (!c.placeholders) return true;

    const keys = Object.keys(c.placeholders);
    for (const key of keys) {
      const placeholderItems = c.placeholders[key];
      if (
        Array.isArray(placeholderItems) &&
        placeholderItems.filter((pi) => pi.fields).length > 0
      ) {
        return true;
      }
    }
    return false;
  });
  const topMainComponentData = mainData?.[0];

  const componentName = computed(() => mainData?.find((c) => c?.uid === uid)?.componentName);
  const componentRouteIndex = computed(() =>
    !isServer() && window?.IS_STORYBOOK ? 0 : mainData?.findIndex((c) => c.uid === uid)
  );
  const componentItemIndex = computed(() =>
    mainData
      ?.filter((c) => c.componentName === componentName?.value)
      .findIndex((c) => c.uid === uid)
  );

  return { componentRouteIndex, componentItemIndex, topMainComponentData };
}
